/* eslint-disable max-len */
<template lang="pug">
  include ../Bemto
  div(
    v-bem.label='{"bound": true}'
    :class="[{'d-control-input__label--active': value }]"
    :for='id',
  )
    label {{ inputLabel }}
    slot
    span(
      v-if='isRequired'
      v-bem.is_required=''
    ) *
    span.static-hint(
      v-if="hint"
    ) &#8203;  {{ hint }}
    +b.tooltip-wrapper(
      v-if='isTooltip'
      :style="{position: 'absolute', right: '-35px', top: '0'}"
    )
      label-tooltip(
        :tooltip-text='tooltipText'
      )
</template>

<script>

export default {
  name: 'BoundLabel',
  block: 'd-control-input',
  props: {
    labelText: {},
    isTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
    },
    hint: {
      type: String,
    },
    id: {
      type: String,
      required: false,
    },
    value: {},
    inputLabel: {
      type: String,
    },
    isRequired: {
      type: Boolean,
    },
  },
}
</script>
